import React, { Component } from 'react';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App" style={{ background: 'black'}}>

        <div className="info-container" style={{
          position: 'absolute',
          width: '100%',
          top: '20%',
          right: '-20%',
          zIndex: '4000'
        }}>
          <a href="https://www.github.com/pauloportella" style={{ fontSize: '16px',  }}>@pauloportella</a>
        </div>


        <div className="Box">
        

          <svg width="538.0127" height="605" viewBox="-269.00635 -302.5 538.0127 605">          
            <g stroke="#eee" strokeWidth="0.075" fill="none" className="base">
              <circle cy="-250" r="50"/>
              <circle cx="43.30127" cy="-225" r="50"/>
              <circle cx="86.60254" cy="-200" r="50"/>
              <circle cx="129.90381" cy="-175" r="50"/>
              <circle cx="173.20508" cy="-150" r="50"/>
              <circle cx="216.50635" cy="-125" r="50"/>
              <circle cx="-43.30127" cy="-225" r="50"/>
              <circle cy="-200" r="50"/>
              <circle cx="43.30127" cy="-175" r="50"/>
              <circle cx="86.60254" cy="-150" r="50"/>
              <circle cx="129.90381" cy="-125" r="50"/>
              <circle cx="173.20508" cy="-100" r="50"/>
              <circle cx="216.50635" cy="-75" r="50"/>
              <circle cx="-86.60254" cy="-200" r="50"/>
              <circle cx="-43.30127" cy="-175" r="50"/>
              <circle cy="-150" r="50"/>
              <circle cx="43.30127" cy="-125" r="50"/>
              <circle cx="86.60254" cy="-100" r="50"/>
              <circle cx="129.90381" cy="-75" r="50"/>
              <circle cx="173.20508" cy="-50" r="50"/>
              <circle cx="216.50635" cy="-25" r="50"/>
              <circle cx="-129.90381" cy="-175" r="50"/>
              <circle cx="-86.60254" cy="-150" r="50"/>
              <circle cx="-43.30127" cy="-125" r="50"/>
              <circle cy="-100" r="50"/>
              <circle cx="43.30127" cy="-75" r="50" />
              <circle cx="86.60254" cy="-50" r="50"/>
              <circle cx="129.90381" cy="-25" r="50"/>
              <circle cx="173.20508" r="50"/>
              <circle cx="216.50635" cy="25" r="50"/>
              <circle cx="-173.20508" cy="-150" r="50"/>
              <circle cx="-129.90381" cy="-125" r="50"/>
              <circle cx="-86.60254" cy="-100" r="50"/>
              <circle cx="-43.30127" cy="-75" r="50"/>
              <circle cy="-50" r="50"   className="flower"/>
              <circle cx="43.30127" cy="-25" r="50"  className="flower"/>


              <circle cx="86.60254" r="50" />
              <circle cx="129.90381" cy="25" r="50"/>
              <circle cx="173.20508" cy="50" r="50"/>
              <circle cx="216.50635" cy="75" r="50"/>
              <circle cx="-216.50635" cy="-125" r="50"/>
              <circle cx="-173.20508" cy="-100" r="50"/>
              <circle cx="-129.90381" cy="-75" r="50"/>
              <circle cx="-86.60254" cy="-50" r="50"/>
              <circle cx="-43.30127" cy="-25" r="50"  className="flower"/>
              <circle r="50" className="flower center"/>
              <circle cx="43.30127" cy="25" r="50" className="flower"/>
              <circle cx="86.60254" cy="50" r="50"/>
              <circle cx="129.90381" cy="75" r="50"/>
              <circle cx="173.20508" cy="100" r="50"/>
              <circle cx="216.50635" cy="125" r="50"/>
              <circle cx="-216.50635" cy="-75" r="50"/>
              <circle cx="-173.20508" cy="-50" r="50"/>
              <circle cx="-129.90381" cy="-25" r="50"/>
              <circle cx="-86.60254" r="50"/>
              <circle cx="-43.30127" cy="25" r="50"   className="flower"/>
              <circle cy="50" r="50"   className="flower"/>
              <circle cx="43.30127" cy="75" r="50"/>
              <circle cx="86.60254" cy="100" r="50"/>
              <circle cx="129.90381" cy="125" r="50"/>
              <circle cx="173.20508" cy="150" r="50"/>
              <circle cx="-216.50635" cy="-25" r="50"/>
              <circle cx="-173.20508" r="50"/>
              <circle cx="-129.90381" cy="25" r="50"/>
              <circle cx="-86.60254" cy="50" r="50"/>
              <circle cx="-43.30127" cy="75" r="50"/>
              <circle cy="100" r="50"/>
              <circle cx="43.30127" cy="125" r="50"/>
              <circle cx="86.60254" cy="150" r="50"/>
              <circle cx="129.90381" cy="175" r="50"/>
              <circle cx="-216.50635" cy="25" r="50"/>
              <circle cx="-173.20508" cy="50" r="50"/>
              <circle cx="-129.90381" cy="75" r="50"/>
              <circle cx="-86.60254" cy="100" r="50"/>
              <circle cx="-43.30127" cy="125" r="50"/>
              <circle cy="150" r="50"/>
              <circle cx="43.30127" cy="175" r="50"/>
              <circle cx="86.60254" cy="200" r="50"/>
              <circle cx="-216.50635" cy="75" r="50"/>
              <circle cx="-173.20508" cy="100" r="50"/>
              <circle cx="-129.90381" cy="125" r="50"/>
              <circle cx="-86.60254" cy="150" r="50"/>
              <circle cx="-43.30127" cy="175" r="50"/>
              <circle cy="200" r="50"/>
              <circle cx="43.30127" cy="225" r="50"/>
              <circle cx="-216.50635" cy="125" r="50"/>
              <circle cx="-173.20508" cy="150" r="50"/>
              <circle cx="-129.90381" cy="175" r="50"/>
              <circle cx="-86.60254" cy="200" r="50"/>
              <circle cx="-43.30127" cy="225" r="50"/>
              <circle cy="250" r="50"/>
              <path d="M43.30127,-275A50,50 0 0,1 -43.30127,-275" />
              <path d="M259.80762,-100A50,50 0 0,1 216.50635,-175"/>
              <path d="M86.60254,-250A50,50 0 0,1 0,-300"/>
              <path d="M0,-300A50,50 0 1,1 -86.6026,-250"/>
              <path d="M129.90381,-225A50,50 0 0,1 43.30127,-275"/>
              <path d="M173.20508,-200A50,50 0 0,1 86.60254,-250"/>
              <path d="M216.50635,-175A50,50 0 0,1 129.90381,-225"/>
              <path d="M259.80762,-150A50,50 0 0,1 173.20508,-200"/>
              <path d="M259.80762,-50A50,50 0 1,1 259.80762,-150"/>
              <path d="M-43.30127,-275A50,50 0 1,1 -129.90381,-225"/>
              <path d="M259.80762,0A50,50 0 1,1 259.80762,-100"/>
              <path d="M-86.60254,-250A50,50 0 1,1 -173.20508,-200"/>
              <path d="M259.80762,50A50,50 0 1,1 259.80762,-50"/>
              <path d="M-129.90381,-225A50,50 0 1,1 -216.50635,-175"/>
              <path d="M259.80762,100A50,50 0 1,1 259.80762,0"/>
              <path d="M-216.50635,-175A50,50 0 0,1 -259.80762,-100"/>
              <path d="M-259.80762,-150A50,50 0 1,1 -259.80762,-50"/>
              <path d="M-173.20508,-200A50,50 0 1,1 -259.80762,-150"/>
              <path d="M173.20508,200A50,50 0 1,1 259.80762,150"/>
              <path d="M259.80762,150A50,50 0 1,1 259.80762,50"/>
              <path d="M216.50635,175A50,50 0 0,1 259.80762,100"/>
              <path d="M-259.80762,-100A50,50 0 1,1 -259.80762,0"/>
              <path d="M129.90381,225A50,50 0 1,1 216.50635,175"/>
              <path d="M-259.80762,-50A50,50 0 1,1 -259.80762,50"/>
              <path d="M86.60254,250A50,50 0 1,1 173.20508,200"/>
              <path d="M-259.80762,0A50,50 0 1,1 -259.80762,100"/>
              <path d="M43.30127,275A50,50 0 1,1 129.90381,225"/>
              <path d="M-259.80762,150A50,50 0 0,1 -173.20508,200"/>
              <path d="M-259.80762,50A50,50 0 1,1 -259.80762,150"/>
              <path d="M-216.50635,175A50,50 0 0,1 -129.90381,225"/>
              <path d="M-173.20508,200A50,50 0 0,1 -86.60254,250"/>
              <path d="M-129.90381,225A50,50 0 0,1 -43.30127,275"/>
              <path d="M-86.60254,250A50,50 0 0,1 0,300"/>
              <path d="M0,300A50,50 0 1,1 86.6026,250"/>
              <path d="M-259.80762,100A50,50 0 0,1 -216.50635,175"/>
              <path d="M-43.30127,275A50,50 0 0,1 43.30127,275"/>
            </g>


            <g stroke="#eee" strokeWidth="2" strokeLinecap="square" fill="none" className="lines-group" >
                {/* back triangle */}
                {/* <line x1="86.60254" y1="-50" x2="0" y2="100" stroke="white"   /> */}
                {/* <line x1="-86.60254" y1="-50" x2="0" y2="100" stroke="white"   /> */}
                {/* <line x1="86.60254" y1="-50" x2="-86.60254" y2="-50" stroke="white"   /> */}


                <line x1="86.60254" y1="50" x2="-86.60254" y2="-50" stroke="white"   />
                <line x1="-86.60254" y1="50" x2="86.60254" y2="-50" stroke="white"   />
                <line x1="0" y1="100" x2="0" y2="-100" stroke="white"   />


                {/*  square bottom */}
                <line x1="-86.60254" y1="150" x2="86.60254" y2="150" stroke="white"   />
                <line x1="86.60254" y1="50" x2="86.60254" y2="150" stroke="white"   />
                <line x1="-86.60254" y1="50" x2="-86.60254" y2="150" stroke="white"   />

                <line x1="0" y1="100" x2="86.60254" y2="150" stroke="white"   />
                <line x1="0" y1="100" x2="-86.60254" y2="150" stroke="white"   />

                {/* square top */}
                <line x1="0" y1="-100" x2="86.60254" y2="-150" stroke="white"   />
                <line x1="0" y1="-100" x2="-86.60254" y2="-150" stroke="white"   />
                <line x1="-86.60254" y1="-150" x2="86.60254" y2="-150" stroke="white"   />
                {/* back */}
                <line x1="86.60254" y1="-50" x2="86.60254" y2="-150" stroke="white"   />
                <line x1="-86.60254" y1="-50" x2="-86.60254" y2="-150" stroke="white"   />

                {/* right side */}
                <line x1="173.20508" y1="0" x2="86.60254" y2="-150" stroke="white"   />
                <line x1="86" y1="50" x2="173.60254" y2="0" stroke="white"   />
                <line x1="173.20508" y1="0" x2="86.60254" y2="150" stroke="white"   />

                {/* left side */}
                <line x1="-173.20508" y1="0" x2="-86.60254" y2="-150" stroke="white"   />
                <line x1="-86.60254" y1="50" x2="-173.20508" y2="0" stroke="white"   />
                <line x1="-173.20508" y1="0" x2="-86.60254" y2="150" stroke="white"   />

              </g>

              {/* triangle */}
              <g stroke="#eee" strokeWidth="2" fill="white" fillOpacity="1" className="lines-group" >
                <polygon points="86.60254, 50 0, -100 -86.60254, 50"/>
              </g>

          </svg>
        </div>


      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js